import { type FC } from 'react'
import { LinkButton } from '../../../components/Button/LinkButton'
import { INTEGRATION_SETTINGS_PATH } from '../../ProfileSettings/Scheduling/sections/schedulingIntegrationStatus'
import { SchedulingStatusCard } from '../SchedulingStatusCard'

const SUBTITLE = 'Scheduling needs a connected calendar. None of the calendar integrations Scheduling supports are available for this account.'

export interface SchedulingUnavailableStateProps {
  isAdmin: boolean
}

export const SchedulingUnavailableState: FC<SchedulingUnavailableStateProps> = ({ isAdmin }) => (
  <SchedulingStatusCard
    icon={<i className='bi bi-calendar zocks-text-gray-600' />}
    title="Scheduling isn't available for your account"
    subtitle={isAdmin ? SUBTITLE : `${SUBTITLE} Ask your account owner if this can change.`}
  >
    {isAdmin ? (
      <LinkButton variant='primary' to={INTEGRATION_SETTINGS_PATH}>
        Manage your integrations
      </LinkButton>
    ) : null}
  </SchedulingStatusCard>
)
